import React, { Component } from "react";
import CatalogPost from "./CatalogPost";
import PromotionPost from "./PromotionPost";
import SalesPost from "./SalesPost";
import AcceleratorPost from "./AcceleratorPost";
import { withResizeContainer } from "../../normalizer";
import PromotionCard from "./PromotionCard";
import CatalogCard from "./CatalogCard";

class PostFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limitText: 400,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.posts !== this.props.posts) {
      this.setState({ limitText: 400, posts: this.props.posts});
    }
  }

  selectPost(post) {
    switch (post.content_type) {
      case "News":
        return (
          <PromotionCard
            imageSize={this.props.imageSize}
            key={post.id}
            limitText={this.props.limitText}
            title={post.content_title}
            content={post.content}
          />
        );
      case "ProductList":
        return <CatalogCard key={post.id} content={post.content} />;
      case "SalesList":
        return <SalesPost key={post.id} content={post.content} />;
      case "Accelerator":
        return (
          <AcceleratorPost
            key={post.id}
            title={post.content_title}
            content={post.content}
            limitText={this.props.limitText}
            imageSize={this.props.imageSize}
          />
        );
      default:
        return null;
    }
  }
  render() {
    
    // I need to isolate the PromotionPosts so that I can add a title to the container.
    // all other post types already themselves containers

    const posts = this.props.posts.filter((post) => post.active !== false);
    const promotionPosts = posts.filter((post) => post.content_type === "News");
    const otherPosts = posts.filter((post) => post.content_type !== "News");
    const hasPromotionPosts = promotionPosts.length > 0;

    return (
      <div className="post-feed">
        {hasPromotionPosts && (
          <div className="post-feed-promotions">
            <div className="post-feed-promotions-title">Destaque</div>
            {promotionPosts.map((post) => this.selectPost(post))}
          </div>
        )}
        {otherPosts && otherPosts.map((post) => this.selectPost(post))}
      </div>
    );
  }
}

export default withResizeContainer(PostFeed);
